import specialistsImg1 from "./specialists-img1.webp"
import specialistsImg2 from "./specialists-img2.webp"
import specialistsImg3 from "./specialists-img3.webp"
import specialistsImg4 from "./specialists-img4.webp"
import specialistsImg5 from "./specialists-img5.webp"
import servicesImg1 from "./services-img1.webp"
import servicesImg2 from "./services-img2.webp"
import servicesImg3 from "./services-img3.webp"
import forumImg1 from "./forum-img1.webp"
import forumImg2 from "./forum-img2.webp"
import forumImg3 from "./forum-img3.webp"
import forumImg4 from "./forum-img4.webp"
import forumImg5 from "./forum-img5.webp"
import forumImg6 from "./forum-img6.webp"
import forumImg7 from "./forum-img7.webp"
import forumImg8 from "./forum-img8.webp"
import forumImg9 from "./forum-img9.webp"
import blogImg1 from "./our-blog1.webp"
import blogImg2 from "./our-blog2.webp"
import blogImg3 from "./our-blog3.webp"

const Images = {
  specialistsImg1,
  specialistsImg2,
  specialistsImg3,
  specialistsImg4,
  specialistsImg5,
  servicesImg1,
  servicesImg2,
  servicesImg3,
  forumImg1,
  forumImg2,
  forumImg3,
  forumImg4,
  forumImg5,
  forumImg6,
  forumImg7,
  forumImg8,
  forumImg9,
  blogImg1,
  blogImg2,
  blogImg3,
}

export default Images